export default __webpack_public_path__ + "static/media/phoneInHand.c4a86d71.jpg";